/*
 * Dry Brew - reward ladder, progress bar, 3-pack gate, per-cup, analytics.
 * SPEC 4/5/6/7/8. Config: window.theme.drybrew (snippets/db-config.liquid,
 * rendered from the cart_rewards metaobject). No hardcoded ids or thresholds.
 * Shares window.DryBrew.queue with db-subscription.js so cart writes stay
 * serial - the Cart AJAX API drops concurrent writes.
 *
 * Gate: a 3-pack only blocks checkout when it is NOT sellable standalone
 * (drybrew.sellable_standalone). Flavor 3-packs are add-ons; the Variety
 * 3 Pack can be bought on its own.
 */
(function () {
  'use strict';

  var DB = (window.theme && window.theme.drybrew) || {};
  var STR = DB.strings || {};
  var ROUTES = (window.theme && window.theme.routes) || {};
  var MAP = DB.variants || {};
  if (!DB.variants) return;

  var THREE_PACK = 900;
  var MAX_PASSES = 4;
  var passes = 0;

  window.DryBrew = window.DryBrew || {};
  if (!window.DryBrew.queue) window.DryBrew.queue = Promise.resolve();

  function enqueue(fn) {
    window.DryBrew.queue = window.DryBrew.queue.then(fn).catch(function (e) {
      console.warn('[Dry Brew]', e);
    });
    return window.DryBrew.queue;
  }

  function money(c) {
    var t = window.theme || {};
    if (typeof t.formatMoney !== 'function') return '$' + (c / 100).toFixed(2);
    return t.formatMoney(c, t.moneyFormat);
  }

  function json(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (b) { if (!r.ok) throw b; return b; });
    });
  }

  function meta(id) { return MAP[String(id)] || {}; }
  function giftTier(i) { return i.properties && i.properties._gift; }
  function fill(s, k, v) { return String(s || '').split(k).join(v); }

  function track(name, params) {
    var d = params || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, d));
    document.dispatchEvent(new CustomEvent('db:' + name, { detail: d, bubbles: true }));
  }

  /* ------------------------------------------------------------- analysis */

  function analyse(cart) {
    var s = {
      preDiscount: 0, bites: 0, hasAnchor: false, threePack: false,
      subscription: false, gifts: {}, tiers: [], total: cart.total_price || 0
    };
    var items = cart.items || [];

    items.forEach(function (it) {
      var m = meta(it.variant_id);
      s.bites += (m.pack || 0) * it.quantity;
      var tier = giftTier(it);
      if (tier) { s.gifts[tier] = it; return; }
      var unit = it.original_price != null ? it.original_price : it.price;
      s.preDiscount += unit * it.quantity;
      if (m.anchor) s.hasAnchor = true;
      if (it.selling_plan_allocation) s.subscription = true;
    });

    items.forEach(function (it) {
      if (giftTier(it)) return;
      var m = meta(it.variant_id);
      if (m.pack === 3 && m.standalone === false && !s.hasAnchor) s.threePack = true;
    });

    if (s.gifts.tier1) s.tiers.push('tier1');
    if (s.gifts.tier2) s.tiers.push('tier2');
    s.freeShipping = s.subscription
      ? !!DB.subFreeShipping
      : s.preDiscount >= DB.freeShipThreshold;
    return s;
  }

  /* ------------------------------------------------------- reward ladder */

  function addGift(tier) {
    return json(ROUTES.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(DB.giftVariantId), quantity: 1, properties: { _gift: tier } }]
      })
    }).then(function () { track('gift_unlocked', { tier: tier }); return true; })
      .catch(function () { return false; }); // out of stock: suppress silently
  }

  function removeLine(key) {
    return json(ROUTES.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  // One mutation per pass, then re-sync. Converges because every branch is
  // conditional on state it changes.
  function reconcile(s) {
    if (!DB.giftVariantId) return null;

    // Revoke first - a cart that no longer qualifies must never keep a gift.
    if (!s.hasAnchor && (s.gifts.tier1 || s.gifts.tier2)) {
      var stale = s.gifts.tier1 || s.gifts.tier2;
      return removeLine(stale.key).then(function () {
        toast(STR.giftRemoved);
        track('gift_revoked', { tier: giftTier(stale) });
      });
    }
    if (s.gifts.tier2 && s.preDiscount < DB.tier2Threshold) {
      return removeLine(s.gifts.tier2.key).then(function () {
        toast(STR.giftRemoved);
        track('gift_revoked', { tier: 'tier2' });
      });
    }

    // Grant only when gift lines can actually price at zero.
    if (!DB.giftPricingReady) return null;

    if (DB.tier1Enabled && s.hasAnchor && !s.gifts.tier1) return addGift('tier1');
    if (s.hasAnchor && s.preDiscount >= DB.tier2Threshold && !s.gifts.tier2) return addGift('tier2');
    return null;
  }

  /* ------------------------------------------------------------ rendering */

  function drawerBody() { return document.querySelector('[data-cart-drawer-body]'); }

  // Reuses the theme's own cart-message classes so the bar inherits brand
  // styling and its width transition instead of introducing new colours.
  function progressEl() {
    var body = drawerBody();
    if (!body) return null;
    var el = body.querySelector('[data-db-progress]');
    if (el) return el;
    el = document.createElement('p');
    el.className = 'cart-message cart-message--drawer';
    el.setAttribute('data-db-progress', '');
    el.innerHTML =
      '<span class="cart-message__default" data-db-progress-copy></span>' +
      '<span class="cart-message__progress-holder">' +
      '<progress class="cart-message__progress" data-db-bar value="0" max="100"></progress>' +
      '<progress class="cart-message__progress" data-db-bar max="100"></progress>' +
      '</span>';
    body.insertBefore(el, body.firstChild);
    return el;
  }

  function progressCopy(s) {
    if (s.total === 0) return STR.emptyCart;
    if (s.subscription && DB.subFreeShipping) return STR.subscriber;
    if (s.preDiscount >= DB.tier2Threshold) return STR.tier2Unlocked;

    var remaining = DB.tier2Threshold - s.preDiscount;
    // Never say "add $0.50" - round up to the item that actually clears it.
    if (remaining <= THREE_PACK) return STR.withinOne;
    if (s.gifts.tier1) return fill(STR.approaching, '||amount||', money(remaining));
    if (!s.hasAnchor) return STR.belowTier1;
    return fill(STR.approaching, '||amount||', money(remaining));
  }

  function renderProgress(s) {
    var el = progressEl();
    if (!el) return;
    var pct = DB.tier2Threshold > 0
      ? Math.max(0, Math.min(100, Math.round((s.preDiscount / DB.tier2Threshold) * 100)))
      : 0;
    el.querySelectorAll('[data-db-bar]').forEach(function (bar) {
      bar.value = pct;
      bar.style.setProperty('--progress-width', pct + '%');
    });
    var copy = el.querySelector('[data-db-progress-copy]');
    if (copy) copy.textContent = progressCopy(s);
    el.hidden = s.total === 0 && !STR.emptyCart;
  }

  function renderPerCup(s) {
    var holder = document.querySelector('[data-cart-price-holder]');
    if (!holder) return;
    var el = holder.querySelector('[data-db-percup]');
    if (s.bites <= 0) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('p');
      el.className = 'cart__text';
      el.setAttribute('data-db-percup', '');
      holder.appendChild(el);
    }
    var per = Math.round(s.total / s.bites);
    el.textContent = fill(fill(STR.bitesAndCup, '||bites||', s.bites), '||amount||', money(per));
  }

  // Gift lines: no quantity control, no remove, FREE badge.
  function renderGiftLines() {
    document.querySelectorAll('[data-cart-item]').forEach(function (row) {
      var isGift = row.getAttribute('data-db-gift') === 'true';
      if (!isGift) return;
      row.querySelectorAll('input, button').forEach(function (c) {
        if (c.closest('[data-cart-remove]') || c.hasAttribute('data-quantity-field') ||
            c.hasAttribute('data-quantity-selector')) {
          c.disabled = true;
          c.setAttribute('aria-disabled', 'true');
        }
      });
    });
  }

  function renderGate(s) {
    var btn = document.querySelector('[data-db-checkout]');
    if (!btn) return;
    var blocked = !!(DB.gateEnabled && s.threePack);
    btn.disabled = blocked;
    btn.classList.toggle('is-disabled', blocked);

    var msg = document.querySelector('[data-db-gate]');
    if (blocked && !msg) {
      msg = document.createElement('p');
      msg.className = 'cart__errors__content';
      msg.setAttribute('data-db-gate', '');
      msg.setAttribute('role', 'alert');
      msg.textContent = STR.gateBlocked;
      btn.parentNode.insertBefore(msg, btn);
      track('gate_blocked', {});
    } else if (!blocked && msg) {
      msg.remove();
    }
  }

  var lastShipping = null;
  function renderAll(cart, s) {
    renderProgress(s);
    renderPerCup(s);
    renderGiftLines();
    renderGate(s);

    if (lastShipping !== null && lastShipping !== s.freeShipping && s.freeShipping) {
      track('free_shipping_unlocked', { cart_value: s.preDiscount });
    }
    lastShipping = s.freeShipping;
  }

  /* ---------------------------------------------------------------- toast */

  function toast(text) {
    if (!text) return;
    var el = document.querySelector('[data-db-toast]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-db-toast', '');
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
        'background:currentColor;color:inherit;padding:10px 16px;border-radius:4px;' +
        'font-size:14px;z-index:9999;opacity:0;transition:opacity .2s;pointer-events:none;';
      document.body.appendChild(el);
    }
    var inner = '<span style="color:#fff;mix-blend-mode:difference">' + text + '</span>';
    el.innerHTML = inner;
    el.style.opacity = '1';
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.style.opacity = '0'; }, 2600);
  }

  /* ----------------------------------------------------------------- sync */

  function readCart() {
    return json(ROUTES.cart_url + '.js', { headers: { Accept: 'application/json' } });
  }

  function sync(fromMutation) {
    return readCart().then(function (cart) {
      var s = analyse(cart);
      renderAll(cart, s);

      if (passes >= MAX_PASSES) return;
      var action = reconcile(s);
      if (!action) { passes = 0; return; }

      passes++;
      return enqueue(function () {
        return Promise.resolve(action).then(function () {
          document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
          return sync(true);
        });
      });
    }).catch(function (e) { console.warn('[Dry Brew] sync failed', e); });
  }

  var debounced = (function () {
    var t;
    return function () { clearTimeout(t); t = setTimeout(function () { passes = 0; sync(); }, 150); };
  })();

  /* -------------------------------------------------------------- wiring */

  function init() {
    ['theme:cart:open', 'theme:cart:close', 'theme:cart:change', 'theme:cart:added']
      .forEach(function (e) { document.addEventListener(e, debounced); });

    if (typeof window.subscribe === 'function' && window.theme.PUB_SUB_EVENTS &&
        window.theme.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.cartUpdate, debounced);
    }

    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && window.MutationObserver) {
      new MutationObserver(debounced).observe(drawer, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var rail = e.target.closest('[data-db-rail-item]');
      if (rail) track('flavor_rail_add', { variant: rail.getAttribute('data-variant-id') });
      var co = e.target.closest('[data-db-checkout]');
      if (co && !co.disabled) track('begin_checkout', {});
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'selling_plan') {
        track('subscription_toggled', { on: !!e.target.value });
      }
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
